"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ColumnStates = void 0;
const change_case_1 = require("change-case");
const mobx_1 = require("mobx");
const ColumnState_1 = require("./ColumnState");
const ColumnStorage_1 = require("./ColumnStorage");
/** A reactive/observable wrapper around our columns. */
class ColumnStates {
    constructor() {
        // The top-level list of columns
        this.columns = [];
        this.map = new Map();
        this.storage = new ColumnStorage_1.ColumnStorage(this);
        (0, mobx_1.makeAutoObservable)(this);
    }
    /**
     * Updates our internal columns states when `props.columns` changes.
     *
     * We handle sessionStorage here b/c we allow the user to either provide their own
     * storage key, or calc the storage key based on the currently-visible columns.
     * So like you expand a column, and new columns show up, but we'll remember they
     * were hidden last time you looked at this specific expansion of columns.
     */
    setColumns(columns, visibleColumnsStorageKey) {
        if (columns.some((c) => c.canHide)) {
            // We optionally auto-calc visible columns based on the currently-_potentially_-visible columns
            visibleColumnsStorageKey !== null && visibleColumnsStorageKey !== void 0 ? visibleColumnsStorageKey : (visibleColumnsStorageKey = (0, change_case_1.camelCase)(columns.map((c) => c.id).join()));
            this.loadVisible(visibleColumnsStorageKey);
        }
        this.columns = columns.map((c) => this.addColumn(c));
        // After the very first non-zero `setColumns`, we disconnect from sessionStorage
        if (columns.length > 0)
            this.storage.done();
    }
    /** Adds a column to our state, i.e. maybe a dynamically loaded column. */
    addColumn(column) {
        const existing = this.map.get(column.id);
        if (!existing) {
            const cs = new ColumnState_1.ColumnState(this, this.storage, column);
            this.map.set(column.id, cs);
            return cs;
        }
        else {
            existing.column = column;
            // Any time a column is re-added (i.e. props.columns changed), re-expand it
            // TODO: verify this eslint ignore
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            if (existing.isExpanded)
                existing.doExpand(true);
            return existing;
        }
    }
    /** Returns the `ColumnState` for the given `id`. */
    get(id) {
        const cs = this.map.get(id);
        if (!cs)
            throw new Error(`No ColumnState for ${id}`);
        return cs;
    }
    /** Returns all currently-expanded columns. */
    get expandedColumns() {
        return this.columns.filter((cs) => cs.isExpanded);
    }
    /** Returns a flat list of all visible columns. */
    get allVisibleColumns() {
        return this.columns.flatMap((cs) => cs.maybeSelfAndChildren);
    }
    setVisibleColumns(ids) {
        for (const cs of this.map.values()) {
            cs.setVisible(ids.includes(cs.column.id));
        }
    }
    loadExpanded(storageKey) {
        this.storage.loadExpanded(storageKey);
    }
    loadVisible(storageKey) {
        this.storage.loadVisible(storageKey);
    }
}
exports.ColumnStates = ColumnStates;
